import { ControllerBase } from "controllerBase";
import global from 'globalMU'

declare var window:any

const EditarParcelaContratoController = ControllerBase.extend({
    name: "EditarParcelaContratoController",
    framework: "knockout",
    ajax: function() {
        return {
            url: "/Orcamento/_EditarParcelaContrato",
            type: "post"
        };
    },

    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
    },

    salvar: function() {
        var self = this;

        global.ajax({
            url: "/Orcamento/AtualizarParcelaContrato",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.identificadorOrcamento,
                parcela: this.toJS(this.model)
            }),

            success: function(data) {

                if (!data) {
                    return;
                }

                if (self.finalizarEdicaoCallback) {
                    self.finalizarEdicaoCallback(data);
                }
            }
        });

    }

});

window.EditarParcelaContratoController = EditarParcelaContratoController

export {
    EditarParcelaContratoController
}